export default __webpack_public_path__ + "static/post_bg-d2fc8f54a7a98a95d8bcbb2164d36c84.svg";